export const getTrustedPartnerList = (req) => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json',
    'site_id': req?.site_id,
    'access_token': req?.accessToken
     },
  };
  return fetch('/shared/api/trustedPartnerData', requestOptions).then((response)=>response.json())

}